import { Breadcrumbs, Link } from "@mui/material"
import ContentExtraSmall from "./ContentExtraSmall"
import { useContext, useEffect, useState } from "react"
import { AppContext } from "contexts/AppContext"


const ProductBreadcrumb = (props) => {
    const { styleGuide, brandData } = useContext(AppContext)
    const [breadcrumb, setBreadcrumb] = useState(null)
    
    useEffect(() => {
        let subCategories = (brandData?.features?.displaySeasonCategoriesOnly 
            ? props.productDetails?.subCategories?.filter(sc => sc.categoryType === 'SEASON')
            : props.productDetails?.subCategories?.filter(sc => sc.categoryType !== 'SEASON')) || []

        if(subCategories.length <= 0) {
            subCategories = []
            let categories = (brandData?.features?.displaySeasonCategoriesOnly 
                ? props.productDetails?.categories?.filter(sc => sc.categoryType === 'SEASON')
                : props.productDetails?.categories?.filter(sc => sc.categoryType !== 'SEASON')) || []
            categories?.forEach(c => {
                subCategories.push({categoryName: c.categoryName, subCategoryName: '', categoryType: c.categoryType})
            })
        }
        let subCategory = subCategories?.length ? subCategories[0] : null
        if(subCategories?.length >= 2) {
            const userEnteredParams = JSON.parse(localStorage.getItem('userEnteredParams') || '{}')
            if(userEnteredParams.shop) {
                const existingFilters = userEnteredParams.shop.filter(item => Number(item.ShopID) === Number(props.ShopID))
                const filterHasCategory = existingFilters?.length && existingFilters[0].categoryFilterValue?.length
                if(filterHasCategory){
                    const filterHasSubCategory = existingFilters[0].subCategoryFilterValue?.length
                    if(filterHasSubCategory) {
                        const filterBreadcrumb = subCategories.find(c => c.categoryName === existingFilters[0].categoryFilterValue[0] && c.subCategoryName === existingFilters[0].subCategoryFilterValue[0])
                        if(filterBreadcrumb) {
                            subCategory = filterBreadcrumb
                        }
                    } else {
                        const filterBreadcrumb = subCategories.find(c => c.categoryName === existingFilters[0].categoryFilterValue[0])
                        if(filterBreadcrumb) {
                            subCategory = filterBreadcrumb
                        }
                    }
                }
            }
        }
        setBreadcrumb(subCategory)
    }, [props.productDetails])

    return (
        <Breadcrumbs aria-label="breadcrumb" style={{fontFamily: styleGuide.fontFamily, fontSize: styleGuide.contentExtraSmallFontSize}}>
            <Link underline="hover" color="inherit" href={`/shop/${props.ShopID}`} >
                Shop
            </Link>
            {
                !!breadcrumb?.categoryName &&
                <Link underline="hover" color="inherit" href={`/shop/${props.ShopID}?category=${encodeURIComponent(breadcrumb.categoryName)}`} >
                    {breadcrumb.categoryName}
                </Link>
            }
            {
                !!breadcrumb?.subCategoryName &&
                <Link underline="hover" color="inherit" href={`/shop/${props.ShopID}?category=${encodeURIComponent(breadcrumb.categoryName)}&subCategory=${encodeURIComponent(breadcrumb.subCategoryName)}`} >
                    {breadcrumb.subCategoryName}
                </Link>
            }
            <ContentExtraSmall>{props.productTitle}</ContentExtraSmall>
        </Breadcrumbs>
    )

}


export default ProductBreadcrumb